import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@shared/services/api.service';
import { LoginApi, LoginApiPayload } from '../models/login-api.model';

@Injectable({
  providedIn: 'root',
})
export class LoginApiService {

  static apiContext = 'login';

  private _apiService = inject(ApiService);

  login$(payload: LoginApiPayload): Observable<LoginApi | null> {
    return this._apiService.post<LoginApi>({
      url: LoginApiService.apiContext,
      body: payload,
    });
  }
}
